import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/Services/RemuneracaoMedicaApi'

const itemDefault = () => ({ id: '', descricao: '', codigoHis: '', status: 'Ativo' })
const filtrosDefault = () => ({
  descricao: '',
  codigoHis: '',
  status: null,
  origem: null,
  periodoCriacaoInicio: null,
  periodoCriacaoFim: null,
})

@Module({ namespaced: true, name: 'TransacaoFinanceiraStore' })
export default class TransacaoFinanceiraStore extends VuexModule {
  lista: any[] = []
  total: number = 0
  pagina: number = 1
  qtdPorPagina: number = 20
  filtros: any = filtrosDefault()
  item: any = itemDefault()
  modalCriarEditar: boolean = false
  statusOptions: any[] = []
  origemOptions: any[] = []

  @Mutation
  setLista(value: any[]) { this.lista = value }

  @Mutation
  setTotal(value: number) { this.total = value }

  @Mutation
  setPagina(value: number) { this.pagina = value }

  @Mutation
  setFiltros(value: any) { this.filtros = value }

  @Mutation
  limparFiltros() {
    this.filtros = filtrosDefault()
    this.pagina = 1
  }

  @Mutation
  setItem(value: any) { this.item = { ...value } }

  @Mutation
  limparItem() { this.item = itemDefault() }

  @Mutation
  setModalCriarEditar(value: boolean) { this.modalCriarEditar = value }

  @Mutation
  setStatusOptions(value: any[]) { this.statusOptions = value }

  @Mutation
  setOrigemOptions(value: any[]) { this.origemOptions = value }

  @Action
  async carregarEnums() {
    const [status, origem] = await Promise.all([
      RemuneracaoMedicaApi.getListagemEnum('StatusTransacaoFinanceira'),
      RemuneracaoMedicaApi.getListagemEnum('OrigemCadastro'),
    ])
    if (status.success) this.context.commit('setStatusOptions', (status.data || []).filter((o: any) => o.key !== 'Removido'))
    if (origem.success) this.context.commit('setOrigemOptions', origem.data || [])
  }

  @Action
  async getAll() {
    try {
      const params = { ...this.filtros, pagina: this.pagina, qtdPorPagina: this.qtdPorPagina }
      const request = await RemuneracaoMedicaApi.getTransacaoFinanceiraListagem(params)
      if (request.success) {
        this.context.commit('setLista', request.data.itens || [])
        this.context.commit('setTotal', request.data.totalRegistros || 0)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar as transações financeiras.' }
    }
  }

  @Action
  async salvar() {
    try {
      const params = {
        id: this.item.id || null,
        descricao: this.item.descricao,
        codigoHis: this.item.codigoHis,
        status: this.item.status,
      }
      return await RemuneracaoMedicaApi.upsertTransacaoFinanceira(params)
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar a transação financeira.' }
    }
  }

  @Action
  async remover(id: string) {
    try {
      return await RemuneracaoMedicaApi.removeTransacaoFinanceira(id)
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao excluir a transação financeira.' }
    }
  }
}
